import EditLicenseModal from './EditLicenseModalContainer'
export { default as AssigneeTab } from './components/AssigneeTab'

export default EditLicenseModal
